<template>
    <div>
        <form novalidate class="md-layout" @submit.prevent="validateEmail" v-show="showStep1">
            <md-card class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <md-card-header>
                    <div v-show="error" class="alert alert-danger fade show" role="alert">
                        {{ alertMessage }}
                    </div>
                    <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('reset')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('your_password_title')}}</strong></h3>
                </md-card-header>
                <md-card-content class="ml-4 mr-4">
                    <strong>{{$t('forgot_password_text_label')}}</strong>
                    <div class="md-layout md-gutter mt-4">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('email')">
                                <md-icon>email</md-icon>
                                <label>{{$t('your_email')}}</label>
                                <md-input type="email" v-model="form.email" md-dense :disabled="sending"></md-input>
                                <span class="md-error" v-if="!$v.form.email.required">{{$t('required.email')}}</span>
                                <span class="md-error" v-else-if="!$v.form.email.email">{{$t('invalid.email')}}</span>
                            </md-field>
                        </div>
                    </div>
                </md-card-content>
                <md-progress-bar md-mode="indeterminate" v-if="sending" />
                <md-card-header class="ml-4 mr-4">
                    <btn :disabled="sending" type="submit" color="info" class="btn-block btn-rounded mb-4 mx-auto">{{$t('validate')}}</btn>
                    <p class="font-small blue-text"><localized-link to="" class="blue-text ml-1">{{$t('back')}}</localized-link></p>
                    <p class="small grey-text">{{$t('forgot_password_text_note')}}</p>
                </md-card-header>
            </md-card>
            <md-snackbar :md-active.sync="emailSaved">{{$t('email_sent_successfully_please_check_your_email')}} {{ lastEmail }}!</md-snackbar>
        </form>
        <div class="md-layout" v-show="showStep2">
            <md-card class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <md-card-header>
                    <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('reset')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('your_password_title')}}</strong></h3>
                </md-card-header>
                <md-card-content class="ml-4 mr-4">
                    <strong>{{$t('how_would_recover_your_password')}}</strong>
                    <div class="md-layout md-gutter mt-4">
                        <div class="md-layout-item md-small-size-100">
                            <button :disabled="sending" @click="sendResetLink"  class="btn-rounded btn btn-info btn-sm ripple-parent btn-forgot">{{$t('has_access_mail')}}</button>
                            <p class="small grey-text">{{$t('description_has_access_mail')}}</p>
                        </div>
                    </div>
                    <hr />
                    <div class="md-layout md-gutter mt-4">
                        <div class="md-layout-item md-small-size-100">
                            <button :disabled="sending" @click="showFormSendTrainer" class="btn-rounded btn btn-info btn-sm ripple-parent btn-forgot">{{$t('has_not_access_mail')}}</button>
                            <p class="small grey-text">{{$t('description_has_not_access_mail')}}</p>
                        </div>
                    </div>
                </md-card-content>
                <md-progress-bar md-mode="indeterminate" v-if="sending" />
                <md-card-header class="ml-4 mr-4">                    
                    <p class="font-small blue-text"><localized-link to="" class="blue-text ml-1">{{$t('back')}}</localized-link></p>
                </md-card-header>
            </md-card>            
        </div>
        <div class="md-layout" v-show="showStep3">
            <md-card class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <md-card-header>
                    <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('reset')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('your_password_title')}}</strong></h3>
                </md-card-header>
                <md-card-content class="ml-4 mr-4">
                    <strong>{{$t('description_generate_new_password')}}</strong>                    
                </md-card-content>
                <md-progress-bar md-mode="indeterminate" v-if="sending" />
                <md-card-header class="ml-4 mr-4">
                    <btn :disabled="sending" @click="sendPasswordTrainer" type="button" color="info" class="btn-block btn-rounded mb-4 mx-auto">{{$t('generate_new_password')}}</btn>
                    <p class="font-small blue-text"><localized-link to="" class="blue-text ml-1">{{$t('back')}}</localized-link></p>
                </md-card-header>
            </md-card>            
        </div>
        <div class="md-layout" v-show="showMessageSuccess1">
            <md-card class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <md-card-header>
                    <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('reset')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('your_password_title')}}</strong></h3>
                </md-card-header>
                <md-card-content class="ml-4 mr-4">
                    <strong class="deep-green-text">{{$t('email_sent_successfully_please_check_your_email')}} {{ lastEmail }}!</strong>                    
                </md-card-content>
                <md-card-header class="ml-4 mr-4">
                    <p class="font-small blue-text"><localized-link to="" class="blue-text ml-1">{{$t('back')}}</localized-link></p>
                </md-card-header>
            </md-card>            
        </div>
        <div class="md-layout" v-show="showMessageSuccess2">
            <md-card class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <md-card-header>
                    <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('reset')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('your_password_title')}}</strong></h3>
                </md-card-header>
                <md-card-content class="ml-4 mr-4">
                    <strong class="deep-green-text">{{$t('email_sent_successfully_to_trainer1')}} {{ lastEmail }}. {{$t('email_sent_successfully_to_trainer2')}}</strong>                    
                </md-card-content>
                <md-card-header class="ml-4 mr-4">
                    <p class="font-small blue-text"><localized-link to="" class="blue-text ml-1">{{$t('back')}}</localized-link></p>
                </md-card-header>
            </md-card>            
        </div>
    </div>    
</template>

<script>
import { Btn } from 'mdbvue';
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import { BASE_API } from '../helpers/base'
import LocalizedLink from '@/components/Menu'

export default {
    name: 'ForgotCheckEmail',
    mixins: [validationMixin],
    data(){
        return {
            form: {
                email: null
            },
            sending: false,
            emailSaved: false,
            lastEmail: null,
            error: false,
            alertMessage: null,
            showStep1: true,
            showStep2: false,
            showStep3: false,
            showMessageSuccess1: false,
            showMessageSuccess2: false
        }
    },
    validations: {
        form: {
            email: {
                required,
                email
            }
        }
    },
    methods: {
        getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]

            if (field) {
                return {
                'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        clearForm () {
            this.$v.$reset()
            this.form.email = null
        },
        checkForgotEmail () {
            this.sending = true
            this.error = false

            let data = {
                email: this.form.email,
            }

            axios.post(`${BASE_API}/search_forgot_pwd`, data).then(resp => {
                if(resp.data.status_code === 200){
                    this.lastEmail = `${this.form.email}`

                    if(resp.data.data_info.has_trainer === 1){
                        this.showStep1 = false
                        this.showStep2 = true
                        this.sending = false
                    } else {
                        // l'utilisateur n'a pas de formateur, on envoi directement le lien de réinitialisation
                        this.sendResetLink()                        
                    }                    
                }else{
                    this.sending = false
                    this.error = true;
                    this.alertMessage = this.$t('email_not_found')
                }
                console.log(resp.data);
            }).catch(error => {
                console.log(error);
            });
        },
        sendResetLink () {
            this.sending = true
            this.error = false

            let data = {
                email: this.lastEmail,
            }

            axios.post(`${BASE_API}/forgot_password`, data).then(resp => {
                if(resp.data.status_code === 200){
                    window.setTimeout(() => {                            
                        //this.emailSaved = true
                        this.sending = false

                        if(this.showStep2 === false) {
                            this.clearForm()
                        }
                        this.showStep1 = false
                        this.showStep2 = false
                        this.showMessageSuccess1 = true
                    }, 1500)
                }else{
                    this.sending = false
                    this.error = true;
                    this.alertMessage = this.$t('email_not_found')
                }
                console.log(resp.data);
            }).catch(error => {
                console.log(error);
            });
        },
        showFormSendTrainer () {
            this.showStep1 = false
            this.showStep2 = false
            this.showStep3 = true
        },
        sendPasswordTrainer () {
            this.sending = true
            this.error = false

            let data = {
                email: this.lastEmail,
            }

            axios.post(`${BASE_API}/send_pwd_trainer`, data).then(resp => {
                if(resp.data.status_code === 200){
                    window.setTimeout(() => {                            
                        //this.emailSaved = true
                        this.sending = false

                        this.showStep1 = false
                        this.showStep2 = false
                        this.showStep3 = false
                        this.showMessageSuccess2 = true
                    }, 1500)
                }else{
                    this.sending = false
                    this.error = true;
                    this.alertMessage = this.$t('email_not_found')
                }
                console.log(resp.data);
            }).catch(error => {
                console.log(error);
            });
        },
        validateEmail () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.checkForgotEmail()
            }
        }
    },
    components: {
        Btn,
        LocalizedLink
    }
}
</script>

<style scoped>
.md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
}
@media (max-width: 425px){
    .md-card-header,
    .md-card-content {
        margin: 0 !important;
    }
}
.btn-forgot {
    width: 100%;
    padding: 15px;
    border-radius: 5px !important;
}
.deep-green-text {
    color:#8dc572;
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotCheckEmail.vue